import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import {type ZodErrorMap, z} from "zod";
import {zodI18nMap} from "zod-i18n-map";
import zodFr from "zod-i18n-map/locales/fr/zod.json";
import translationMytour from "./locales/fr/translation.json";

const resources = {
  fr: {
    translation: translationMytour,
  },
};

i18next.use(initReactI18next).init({
  resources,
  fallbackLng: "fr",
  lng: "fr",
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export function initI18n() {
  i18next.init({
    lng: "fr",
    resources: {
      fr: {zod: zodFr, translation: translationMytour},
    },
  });
  const customErrorMap: ZodErrorMap = (issue, ctx) => {
    // NaN from cleared decimal inputs → user-friendly message instead of "Expected number, received nan"
    if (issue.code === "invalid_type" && issue.expected === "number") {
      return {message: "Obligatoire"};
    }
    return zodI18nMap(issue, ctx);
  };
  z.setErrorMap(customErrorMap);
}

export const i18n = i18next;
